import { styled } from '@mui/material/styles';

import Grid from '@mui/material/Grid';
import Text from './Text';
import { useTranslation } from "react-i18next";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: (theme.vars ?? theme).palette.background.paper,
    border: '1px solid #000000',
    fontSize: 16,
    padding: '6px 25px 6px 25px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export default function SelectFeld({ id, q, text, description, val, callback, error, reset, color }) {

  const { i18n, t } = useTranslation();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    callback(event.target.value);
    //reset();
  };

  return (

    <Grid className="block" id={id} >

      <div className="paragraph">
        <Text variant="normal" text={text} color={color} />
      </div>

      {/* <FormControl sx={{ m: 1, width: "100%" }} variant="standard" > */}
      <div>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          className="input"
          value={val}
          onChange={handleChange}
          input={<BootstrapInput />}
        >
          <MenuItem value={0}><em>-</em></MenuItem>
          <MenuItem value={1}>{t("formular.art.wild")} </MenuItem>
          <MenuItem value={2}>{t("formular.art.balkon")} </MenuItem>
          <MenuItem value={3}>{t("formular.art.zimmer")} </MenuItem>
          <MenuItem value={4}>{t("formular.art.garten")} </MenuItem>
          <MenuItem value={5}>{t("formular.art.kultur")} </MenuItem>
          <MenuItem value={6}>{t("formular.art.anderes")} </MenuItem>
        </Select>
      </div>
      {/* </FormControl> */}

    </Grid>

  )

}

